import React from 'react'
import { Box, Typography } from '@mui/material'
import BackLink from './BackLink'
import {
  PAGE_HEADER_PADDING,
  PAGE_HEADER_PADDING_BOTTOM,
  DEFAULT_ACCENT_GRADIENT,
} from '../../constants/layout'

interface PageHeaderProps {
  title: string
  subtitle?: string
  actions?: React.ReactNode
  gradient?: string
  meta?: React.ReactNode
  /** A way back to the list this page belongs to, drawn above the title. */
  back?: { label: string; onClick: () => void }
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  gradient = DEFAULT_ACCENT_GRADIENT,
  meta,
  back,
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      p: PAGE_HEADER_PADDING,
      pb: PAGE_HEADER_PADDING_BOTTOM,
      backgroundColor: 'background.default',
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1, pr: 2 }}>
      {back && <BackLink label={back.label} onClick={back.onClick} />}
      <Typography component="h2" sx={{
        fontWeight: 700,
        fontSize: '1.4rem',
        letterSpacing: '-0.02em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...(gradient.includes('gradient') ? {
          background: gradient,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        } : {
          color: gradient,
        }),
      }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            mt: 0.5,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {subtitle}
        </Typography>
      )}
      {meta}
    </Box>
    {actions && (
      <Box sx={{ flexShrink: 0 }}>
        {actions}
      </Box>
    )}
  </Box>
)

export default PageHeader
